import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer
      className="border-t border-[rgba(117,148,122,0.15)] bg-[#F3F4F1]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/images/ericeira-works-logo.webp"
              alt="Ericeira Works"
              className="h-12 w-auto object-contain "
              style={{ mixBlendMode: "multiply" }}
            />
          </Link>
          <p className="mt-4 text-sm text-[#5C6B5D] max-w-xs leading-relaxed">
            {t.footer.tagline}
          </p>
          <p className="mt-4 text-sm text-[#5C6B5D] max-w-xs leading-relaxed">
            {t.footer.picture_credits}
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6B5D]">
            {t.nav.freelancers}
          </h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <Link
                to="/freelancers"
                className="text-[#202C21] hover:text-[#75947A] transition-colors"
                data-testid="footer-link-freelancers"
              >
                {t.freelancers.view_all}
              </Link>
            </li>
            <li>
              <a
                href="/#project-form"
                className="text-[#202C21] hover:text-[#75947A] transition-colors"
                data-testid="footer-link-project"
              >
                {t.nav.project}
              </a>
            </li>
            <li>
              <a
                href="/#about"
                className="text-[#202C21] hover:text-[#75947A] transition-colors"
                data-testid="footer-link-about"
              >
                {t.nav.about}
              </a>
            </li>
          </ul>
        </div>

        <div className="md:text-right">
          <p className="text-xs text-[#8A9A8B]">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
